/**
 * An object whose values create actions.
 *
 * @typedef ActionFactory
 */
/**
 * Fills in the type and reducer parameters on an an object values are
 * action creators (see: {@link simpleAction}, {@link payloadAction}, {@link handlerAction}.)
 *
 * @param actionParts an object whose values are action creators
 * @param reducer the scope (and value of the "reducer" key) on all of the actions created by these actions
 * @returns {ActionFactory}
 */
export function actionFactory(actionParts, reducer) {
    return Object.entries(actionParts).reduce((obj, [key, part]) => Object.assign({}, obj, { [key]: part(key, reducer) }), {});
}
